const invalidInputStyles = ['text-red-900', 'outline-red-300', 'placeholder:text-red-300', 'focus:outline-red-300'];
const standardInputStyles = ['outline-gray-300', 'placeholder:text-zinc-400', 'focus:outline-green-600'];

type InputElement = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;

export const csrfToken = (): string => document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? '';

export const csrfHeaders = (): Record<string, string> => {
    const token = csrfToken();
    return token ? {'X-CSRF-Token': token} : {};
};

export const ensureFormCsrfToken = (form: HTMLFormElement): void => {
    const method = (form.method || 'get').toLowerCase();
    if (method === 'get') {
        return;
    }

    const token = csrfToken();
    if (!token) {
        return;
    }

    let input = form.querySelector<HTMLInputElement>('input[name="csrf_token"]');
    if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'csrf_token';
        form.append(input);
    }
    input.value = token;
};

export const markInputInvalid = (input: InputElement, errorTargets: HTMLElement[] = [])=> {
    input.classList.remove(...standardInputStyles);
    input.classList.add(...invalidInputStyles)
    errorTargets.forEach((target) => target.classList.remove('invisible'));
}

export const markInputValid = (input: InputElement, errorTargets: HTMLElement[] = [])=> {
    input.classList.remove(...invalidInputStyles)
    input.classList.add(...standardInputStyles);
    errorTargets.forEach((target) => target.classList.add('invisible'));
}
